/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { styles } from './themes/PlotAreaStyles.css';
import { Dimension } from './PlotArea.types';
import { getAxisLineProps, getBaseLineProps } from './utils';
import { Scale } from '../UNSAFE_Chart';
import { ColorProps } from '../utils/UNSAFE_interpolations/colors';

type Props = {
  yScale: Scale;
  isLog: boolean;
  color?: ColorProps['color'];
  availSpace: Dimension;
  xAxisPosition: 'left' | 'right' | 'top' | 'bottom';
};

export function PlotArea({ color, yScale, isLog, availSpace, xAxisPosition }: Props) {
  const hasBaseLine = !isLog && yScale.domain()[0] < 0 && yScale.domain()[1] > 0;
  const axisLineProps = getAxisLineProps(availSpace, xAxisPosition);
  const baseLineProps = getBaseLineProps(availSpace, yScale.transform(0), xAxisPosition);
  return (
    <>
      <rect {...availSpace} class={styles.plotAreaStyle} style={{ fill: color }}></rect>
      <line {...axisLineProps} class={styles.axisLineStyle} />
      {hasBaseLine && <line {...baseLineProps} class={styles.baseLineStyle} />}
    </>
  );
}
